import { Directive, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';

@Directive({
	selector: '[superAdminGuard]',
})
export class SuperAdminGuardDirective implements OnInit {
	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private authService: AuthenticationService
	) {}

	ngOnInit() {
		if (this.authService.isSuperAdmin()) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}
}
